module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_innlandet_neg.732bcb4d.svg";